// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyCards_root__hW1uM","scrollingDown":"StickyCards_scrollingDown__zjocm","header":"StickyCards_header__OBuRg","cards":"StickyCards_cards__uNGwS"};